import EventBus from "eventing-bus"
import { sectionsData } from "../data/sections-data"
import { constants, getCurrSection } from "../model"

const viewEl = document.querySelector("#section-title-view")

const handleSectionChanged = () => {
  viewEl.classList.remove("show")
  if (getCurrSection() === 3) {
    viewEl.classList.add("section-3")
  } else {
    viewEl.classList.remove("section-3")
  }
  setTimeout(() => {
    const titleText = sectionsData[getCurrSection()]
    if (getCurrSection() !== 4) {
      viewEl.querySelector(".title").innerHTML = titleText
      viewEl.classList.add("show")
    }
  }, 1000)
}

const handleProductZoomClicked = (bool) => {
  if (bool) viewEl.classList.remove("show")
  else viewEl.classList.add("show")
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
EventBus.on(constants.PLAY_PRODUCT_ZOOM, handleProductZoomClicked)
